import * as wjcCore from '@mescius/wijmo';
import * as wjGridFilter from '@mescius/wijmo.grid.filter';
import * as wjInput from '@mescius/wijmo.input';
import * as wjMultirow from '@mescius/wijmo.grid.multirow';

'use strict';

import {ViewChild, Component, AfterViewInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpClient, HttpEventType, HttpRequest} from "@angular/common/http";
import {Store} from "@ngrx/store";
import {ToasterService} from "angular2-toaster";
import {TranslocoService} from '@jsverse/transloco';
import {ActivePromotionConfig} from "../config/active-promotion.config";
import {GalleryComponent, GalleryItem, ImageItem} from '../ui/gallery/index';
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from "@cosbeni/database";
import {joinUrl} from "@cosbeni/auth";
import * as uuid from "uuid";
import {Observable} from 'rxjs';
import {LoadUserAction} from "../ngrx/actions/user.action";
import {ConfirmComponent} from '../ui/modal';

export interface IMessage {
    id: number;
    text: string;
}

@Component({
    standalone: false,
    selector: 'cj-admin-item',
    templateUrl: 'item-management.component.html',
    styleUrls: ["item-management.component.css"]
})

export class ItemManagementComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('itemGrid') itemGrid: wjMultirow.MultiRow;
    @ViewChild('buyerAutoComplete') buyerAutoComplete: wjInput.AutoComplete;
    @ViewChild('sellerAutoComplete') sellerAutoComplete: wjInput.AutoComplete;
    @ViewChild('imageGallery') imageGallery: GalleryComponent;
    @ViewChild('deleteImagePopup') deleteImagePopup: ConfirmComponent;
    message: string = '';
    filter: wjGridFilter.FlexGridFilter;
    predicate: any = {
        id: null,
        place: "",
        lane: "",
        category: "",
        auctionResult: "",
        buyer: null,
        seller: null,
        name: "",
        description: "",
        eventDate: null,
    }
    screenWidth: number;
    user: any;
    preference: any = {};
    reauction: any = {};
    item: any = {};
    itemMap: any = {};
    items: OrientDBCollectionView;
    histories: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    mode: string = "view";
    files: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    denied: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    images: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    imagesAvailable: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    galleryItems: GalleryItem[] = [];
    fileId: number;
    max: number = 512;
    formats: string = ".jpg,.jpeg";
    multiple: boolean = true;
    selectAll: boolean = false;
    showDenied: boolean = true;
    showDropNDrop: boolean = true;
    showResetButton: boolean = true;
    showSelectButton: boolean = true;
    showUploadButton: boolean = false;
    reg: RegExp = /(?:\.([^.]+))?$/;
    caption: Array<string> = [];
    percentComplete: number;
    optionAuction: any[] = [];
    optionAuctionResult: any[] = [];
    optionCategory: any[] = [];
    optionLane: any[] = [];
    optionPlace: any[] = [];
    optionUnit: any[] = [];

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private route: ActivatedRoute, private http: HttpClient, private transloco: TranslocoService) {
        this.store.dispatch(new LoadUserAction())
        this.store.select<any>("activePromotionFeature").subscribe((digitalAuction: any) => {
            if (wjcCore.isObject(digitalAuction.user) && digitalAuction.user.loaded) {
                this.user = digitalAuction.user.user;
                this.dataService.query({
                    sql: "SELECT FROM DA_Preference WHERE username = '" + this.user.name + "'",
                    count: "SELECT FROM DA_Preference WHERE username = '" + this.user.name + "'",
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (wjcCore.isArray(data.results) && data.results.length > 0) {
                        this.preference = Object.assign({}, data.results[0]);
                        if (isOrientDate(this.preference.eventDate)) {
                            this.preference.eventDate = asOrientDate(this.preference.eventDate);
                        }
                    }
                })
            }
        });
        this.items = new OrientDBCollectionView(dataService, ActivePromotionConfig.DATABASE, "SELECT FROM DA_Item", "DA_Item", "", 0, 100, true, true, false)
        this.items.url = ActivePromotionConfig.SERVER_URL;
        this.items.tokenName = ActivePromotionConfig.DATABASE + "_token";
        this.items.sortDescriptions.push(new wjcCore.SortDescription("id", false));
        this.fileId = Math.floor(Math.random() * 20) * 10000;
        this.dataService.query({
            sql: "SELECT FROM DA_Auction ORDER BY eventDate DESC",
            count: "SELECT FROM DA_Auction ORDER BY eventDate DESC",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                for (let auction of data.results) {
                    if (isOrientDate(auction.eventDate)) {
                        auction.eventDate = asOrientDate(auction.eventDate);
                        auction.display = wjcCore.Globalize.formatDate(auction.eventDate, 'yyyy/MM/dd HH:mm:ss') + " " + auction.place + " " + auction.lane;
                    }
                }
                this.optionAuction = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='セリ結果' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='セリ結果' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionAuctionResult = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='商品種別' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='商品種別' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionCategory = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='レーン' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionLane = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='会場名' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionPlace = data.results;
            }
        })
        this.dataService.query({
            sql: "SELECT FROM DA_Master WHERE category ='単位' order by sort",
            count: "SELECT FROM DA_Master WHERE category ='単位' order by sort",
            fetchPlan: "*:1",
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionUnit = data.results;
            }
        })
        this.resizeScreen();
    }

    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
    }

    ngAfterViewInit() {
        this.items.filterOnServer = true;
        this.items.currentChanged.addHandler(this.onCurrentChanged, this);
        this.items.itemsSourceFunction = function (items: any[]) {
            this.itemMap = {};
            for (let item of items) {
                this.itemMap[item['@rid']] = false;
                if (wjcCore.isObject(item.auction) && isOrientDate(item.auction.eventDate)) {
                    item.auction.eventDate = asOrientDate(item.auction.eventDate);
                }
                if (isOrientDate(item.published)) {
                    item.published = asOrientDate(item.published);
                }
            }
            return items;
        }
    }

    onCurrentChanged(sender: any, args: wjcCore.EventArgs): void {
        if (this.items.currentItem != null && this.mode == "view") {
            this.item = Object.assign({}, this.items.currentItem);
            if (wjcCore.isObject(this.item.auction)) {
                for (let auction of this.optionAuction) {
                    if (auction['@rid'] == this.item.auction['@rid']) {
                        this.item.auction = auction;
                    }
                }
            }
            if (wjcCore.isObject(this.item.buyer)) {
                this.buyerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.buyer]);
            }
            if (wjcCore.isObject(this.item.seller)) {
                this.sellerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.seller]);
            }
            if (wjcCore.isObject(this.imageGallery))
                this.imageGallery.reset();
            if (this.item.hasOwnProperty("images") && wjcCore.isArray(this.item.images)) {
                this.galleryItems = [];
                for (let name of this.item.images) {
                    this.galleryItems.push(new ImageItem({
                        src: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name,
                        thumb: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name.replace(".jpg", "_thumb.jpg")
                    }))
                }
            } else {
                this.galleryItems = [];
            }
            this.loadHistories();
        }
    }

    onSelectAllChange() {
        if (this.selectAll) {
            for (let item of this.items.items) {
                this.itemMap[item['@rid']] = true;
            }
        } else {
            for (let item of this.items.items) {
                this.itemMap[item['@rid']] = false;
            }
        }
        this.items.refresh();
    }

    createNew(): void {
        this.mode = "edit";
        let today = new Date();
        let eventDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
        this.item = {
            "@class": "DA_Item",
            "@rid": "#-1:-1",
            id: 0,
            branch: 1,
            auction: null,
            auctionPrice: 1000,
            auctionResult: "未セリ",
            buyer: null,
            buyerCharge: 0.05,
            category: "",
            images: [],
            description: "",
            descriptionImage: "",
            minimumPrice: 1000,
            name: "",
            quantity: 1,
            seller: null,
            sellerCharge: 0.1,
            sort: 10000,
            startPrice: 0,
            unit: "",
            uuid: uuid.v4().split("-").join("")
        }
        if (wjcCore.isObject(this.preference) && !wjcCore.isNullOrWhiteSpace(this.preference.username)) {
            Object.entries(this.item).forEach(([key, value]) => {
                if (this.preference.hasOwnProperty(key)) {
                    if (!key.startsWith("@") && this.preference[key] != null) {
                        this.item[key] = this.preference[key];
                    }
                    if (key == "auction" && wjcCore.isObject(this.preference.auction)) {
                        for (let auction of this.optionAuction) {
                            if (auction['@rid'] == this.preference.auction['@rid']) {
                                this.item.auction = auction;
                            }
                        }
                    }
                }
            });
        }
        if (wjcCore.isObject(this.item.buyer)) {
            this.buyerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.buyer]);
        }
        if (wjcCore.isObject(this.item.seller)) {
            this.sellerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.seller]);
        }
        this.images.sourceCollection = [];
        this.images.refresh();
        this.imagesAvailable.sourceCollection = [];
        this.imagesAvailable.refresh();
    }

    editItem(): void {
        this.mode = "edit";
        if (this.items.currentItem != null) {
            this.item = Object.assign({}, this.items.currentItem);
            if (wjcCore.isObject(this.item.auction)) {
                for (let auction of this.optionAuction) {
                    if (auction['@rid'] == this.item.auction['@rid']) {
                        this.item.auction = auction;
                    }
                }
            }
            if (wjcCore.isObject(this.item.buyer)) {
                this.buyerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.buyer]);
            }
            if (wjcCore.isObject(this.item.seller)) {
                this.sellerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.seller]);
            }
            this.loadImages()
        }
    }

    cancelItem(): void {
        this.mode = "view";
        if (this.items.currentItem != null) {
            this.item = Object.assign({}, this.items.currentItem);
            if (wjcCore.isObject(this.item.auction)) {
                for (let auction of this.optionAuction) {
                    if (auction['@rid'] == this.item.auction['@rid']) {
                        this.item.auction = auction;
                    }
                }
            }
            if (wjcCore.isObject(this.item.buyer)) {
                this.buyerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.buyer]);
            }
            if (wjcCore.isObject(this.item.seller)) {
                this.sellerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.seller]);
            }
        }
    }

    saveItem(): void {
        this.saveItem$().subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
                this.dataService.query({
                    sql: "SELECT FROM DA_Item WHERE uuid = '" + this.item.uuid + "'",
                    count: "SELECT FROM DA_Item WHERE uuid = '" + this.item.uuid + "'",
                    fetchPlan: "*:1",
                }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                    if (data.results.length == 1) {
                        this.item = data.results[0];
                        if (wjcCore.isObject(this.item.auction)) {
                            for (let auction of this.optionAuction) {
                                if (auction['@rid'] == this.item.auction['@rid']) {
                                    this.item.auction = auction;
                                }
                            }
                        }
                    }
                    if (wjcCore.isObject(this.items.currentItem) && this.items.currentItem.id == this.item.id) {
                        let imagesArray = this.items.sourceCollection;
                        let index = imagesArray.indexOf(this.items.currentItem);
                        this.items.sourceCollection[index] = this.item;
                        this.items.refresh();
                        this.mode = "view";
                        if (wjcCore.isObject(this.item.auction)) {
                            for (let auction of this.optionAuction) {
                                if (auction['@rid'] == this.item.auction['@rid']) {
                                    this.item.auction = auction;
                                }
                            }
                        }
                        if (wjcCore.isObject(this.item.buyer)) {
                            this.buyerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.buyer]);
                        }
                        if (wjcCore.isObject(this.item.seller)) {
                            this.sellerAutoComplete.itemsSource = new wjcCore.CollectionView([this.item.seller]);
                        }
                        if (this.item.hasOwnProperty("images") && wjcCore.isArray(this.item.images)) {
                            this.galleryItems = [];
                            for (let name of this.item.images) {
                                this.galleryItems.push(new ImageItem({
                                    src: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name,
                                    thumb: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name
                                }))
                            }
                        }
                    }
                })
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
            }
        )
    }

    saveItem$(): Observable<any> {
        let item = Object.assign({}, this.item);
        if (wjcCore.isDate(item.published)) {
            item.published = wjcCore.Globalize.formatDate(item.published, 'yyyy-MM-dd HH:mm:ss');
        }
        delete item.images;
        let sql = "BEGIN\n"
        let mapItem: any[] = [];
        Object.entries(item).forEach(([key, value]) => {
            if (wjcCore.isNumber(value) && !key.startsWith("@")) {
                if (key != "id" && value != 0) {
                    mapItem.push(key + "=" + value)
                }
            } else if (key == "buyer" || key == "seller" || key == "auction") {
                if (wjcCore.isObject(value)) {
                    mapItem.push(key + "=" + value['@rid'])
                } else {
                    mapItem.push(key + "= null")
                }
            } else {
                if (!key.startsWith("@") && value != null) {
                    if (wjcCore.isString(value)) {
                        let v: string = value;
                        v = v.replace(/\\/g, "\\\\");
                        v = v.replace(/\n/g, "\\n");
                        v = v.replace(/\t/g, "\\t");
                        v = v.replace(/'/g, "\\'");
                        v = v.replace(/"/g, '\\"');
                        value = v;
                    }
                    mapItem.push(key + "='" + value + "'")
                }
            }
        });
        if (this.images.items.length > 0) {
            let filenames = [];
            for (let image of this.images.items) {
                filenames.push(image.name);
            }
            mapItem.push("images=['" + filenames.join("','") + "']")
        }
        if (item['@rid'] == "#-1:-1") {
            sql = sql + "let header = INSERT INTO DA_Item SET id = sequence('item').next(), " + mapItem.join(",") + " return $current\n";
        } else {
            sql = sql + "UPDATE DA_Item SET " + mapItem.join(",") + " WHERE @rid = " + this.item['@rid'] + "\n";
        }
        sql = sql + "COMMIT RETRY 100\n";
        return this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL);
    }

    loadImages() {
        this.images.sourceCollection = [];
        this.images.refresh();
        this.imagesAvailable.sourceCollection = [];
        this.imagesAvailable.refresh();
        if (this.mode == "edit" && this.item.id > 0) {
            this.dataService.get({}, ActivePromotionConfig.SERVER_URL + "/rest/auction/images/" + this.item.id).subscribe(data => {
                let images = [];
                let imagesAvailable = [];
                if (this.item.hasOwnProperty("images") && wjcCore.isArray(this.item.images)) {
                    for (let image of data) {
                        if (this.item.images.indexOf(image.name) < 0 && image.name.indexOf("thumb") < 0) {
                            imagesAvailable.push(image);
                        }
                    }
                    for (let name of this.item.images) {
                        for (let image of data) {
                            if (name == image.name) {
                                images.push(image);
                            }
                        }
                    }
                } else {
                    for (let image of data) {
                        if (image.name.indexOf("thumb") < 0) {
                            imagesAvailable.push(image);
                        }
                    }
                }
                this.images.sourceCollection = images;
                this.images.refresh();
                this.imagesAvailable.sourceCollection = imagesAvailable;
                this.imagesAvailable.refresh();
            })
        }
    }

    loadHistories() {
        this.histories.sourceCollection = [];
        this.histories.refresh();
        if (this.items.currentItem != null) {
            this.dataService.query({
                sql: "SELECT FROM DA_History WHERE item = " + this.item['@rid'] + " order by historyDate desc",
                count: "SELECT FROM DA_History WHERE item = " + this.item['@rid'] + " order by historyDate desc",
                fetchPlan: "*:1",
            }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                if (wjcCore.isArray(data.results)) {
                    for (let history of data.results) {
                        if (isOrientDate(history.historyDate)) {
                            history.historyDate = asOrientDate(history.historyDate);
                        }
                    }
                    this.histories.sourceCollection = data.results;
                    this.histories.refresh();
                }
            })
        }
    }

    publish(): void {
        let sql = "BEGIN\n"
        Object.entries(this.itemMap).forEach(([key, value]) => {
            if (value && key.startsWith("#")) {
                sql = sql + "UPDATE DA_Item SET published = SYSDATE() WHERE @rid = " + key + "\n";
            }
        });
        sql = sql + "COMMIT RETRY 100\n";
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
                this.items.queryData();
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
            }
        );
    }

    unpublish(): void {
        let sql = "BEGIN\n"
        Object.entries(this.itemMap).forEach(([key, value]) => {
            if (value && key.startsWith("#")) {
                sql = sql + "UPDATE DA_Item REMOVE published WHERE @rid = " + key + "\n";
            }
        });
        sql = sql + "COMMIT RETRY 100\n";
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
                this.items.queryData();
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
            }
        );
    }


    copy() {
        let sql = "BEGIN\n"
        Object.entries(this.itemMap).forEach(([key, value]) => {
            if (value && key.startsWith("#")) {
                for (let p of this.items.items) {
                    if (p['@rid'] == key) {
                        let item = Object.assign({}, p);
                        delete item['@rid'];
                        delete item.published;
                        item.auctionPrice = 0;
                        item.auctionResult = "未セリ";
                        item.sort = 10000;
                        item.uuid = uuid.v4().split("-").join("");
                        let mapItem: any[] = [];
                        Object.entries(item).forEach(([key, value]) => {
                            if (wjcCore.isNumber(value) && !key.startsWith("@")) {
                                if (key == "branch") {
                                    let branch = value + 1;
                                    mapItem.push(key + "=" + branch);
                                } else {
                                    mapItem.push(key + "=" + value);
                                }
                            } else if (wjcCore.isArray(value) && !key.startsWith("@")) {
                                if (key == "images") {
                                    mapItem.push(key + "=" + JSON.stringify(item.images));
                                }
                            } else if (key == "buyer" || key == "seller" || key == "auction") {
                                if (wjcCore.isObject(value)) {
                                    if (key == "auction") {
                                        mapItem.push(key + "=" + this.reauction['@rid']);
                                    } else if (key == "seller") {
                                        mapItem.push(key + "=" + value['@rid'])
                                    }
                                }
                            } else {
                                if (!key.startsWith("@") && value != null) {
                                    if (wjcCore.isString(value)) {
                                        let v: string = value;
                                        v = v.replace(/\\/g, "\\\\");
                                        v = v.replace(/\n/g, "\\n");
                                        v = v.replace(/\t/g, "\\t");
                                        v = v.replace(/'/g, "\\'");
                                        v = v.replace(/"/g, '\\"');
                                        value = v;
                                    }
                                    mapItem.push(key + "='" + value + "'")
                                }
                            }
                        });
                        sql = sql + "INSERT INTO DA_Item SET " + mapItem.join(",") + "\n";
                        break;
                    }
                }
            }
        });
        sql = sql + "COMMIT RETRY 100\n";
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('common.save'), this.transloco.translate('admin.saved_message'));
                this.items.queryData();
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('common.save'), this.transloco.translate('admin.failed_message'));
            }
        );
    }

    confirmDeleteImage(): void {
        this.message = this.transloco.translate('admin.confirm_delete_named', {name: this.imagesAvailable.currentItem.name});
        this.deleteImagePopup.modal.show();
    }

    deleteImage() {
        this.dataService.post({}, ActivePromotionConfig.SERVER_URL + '/rest/auction/delete/' + this.item.id + '/' + this.imagesAvailable.currentItem.name).subscribe(data => {
            let command = 'UPDATE DA_Item REMOVE images = \'' + this.imagesAvailable.currentItem.name + '\' WHERE images CONTAINS [\'' + this.imagesAvailable.currentItem.name + '\'] AND id =' + this.item.id;
            this.dataService.command({sql: command}, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                this.loadImages();
            });
        });
    }
    search(): void {
        let where = [];
        if (wjcCore.isNumber(this.predicate.id)) {
            where.push("id = " + this.predicate.id);
        }
        if (wjcCore.isDate(this.predicate.eventDate)) {
            where.push("auction.eventDate >= date('" + wjcCore.Globalize.formatDate(this.predicate.eventDate, 'yyyy-MM-dd') + "','yyyy-MM-dd')");
            where.push("auction.eventDate < date('" + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.predicate.eventDate, 1), 'yyyy-MM-dd') + "','yyyy-MM-dd')");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.place)) {
            where.push("auction.place = '" + this.predicate.place + "'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.lane)) {
            where.push("auction.lane = '" + this.predicate.lane + "'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.category)) {
            where.push("category = '" + this.predicate.category + "'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.auctionResult)) {
            where.push("auctionResult = '" + this.predicate.auctionResult + "'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.name)) {
            where.push("name LIKE '%" + this.predicate.name + "%'");
        }
        if (!wjcCore.isNullOrWhiteSpace(this.predicate.description)) {
            where.push("description LIKE '%" + this.predicate.description + "%'");
        }
        this.items.filterOnServer = false;
        this.items.filterSpecial = where.join(" AND ")
        this.items.filterOnServer = true;
    }

    resetPredicate() {
        this.predicate = {
            id: null,
            place: "",
            lane: "",
            category: "",
            auctionResult: "",
            buyer: null,
            seller: null,
            name: "",
            description: "",
            eventDate: null,
        }
        this.search();
    }

    getImageSrc(item, name): string {
        return ActivePromotionConfig.IMAGE_URL + item.id + '/' + name;
    }

    getCurrentImageSrc(name): string {
        return ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name;
    }

    resetUpload() {
        this.files = new wjcCore.CollectionView([]);
        this.caption = [];
        this.denied = new wjcCore.CollectionView([]);
        this.showUploadButton = false;
    }

    onChange(event: any) {
        let selected = this.files.items;
        let formatCount: any;
        formatCount = this.formats.match(new RegExp("\\.", "g"));
        formatCount = formatCount.length;
        let file: FileList;
        if (event.type == "drop") {
            file = event.dataTransfer.files;
        } else {
            file = event.target.files || event.srcElement.files;
        }

        let extension: any;
        let allowed: boolean;
        for (let i = 0; i < file.length; i++) {
            extension = this.reg.exec(file[i].name);
            extension = extension[1];
            allowed = false;
            for (let j = formatCount; j > 0; j--) {
                let ext = this.formats.split(".")[j];
                if (j == formatCount) {
                    ext = this.formats.split(".")[j] + ",";
                }
                if (extension.toLowerCase() == ext.split(",")[0]) {
                    allowed = true;
                }
            }
            if (allowed) {
                if (file[i].size > this.max * 1024000) {
                    this.denied.items.push({
                        name: file[i].name,
                        size: file[i].size,
                        errorMessage: this.transloco.translate('admin.size_limit_exceeded')
                    });
                    continue;
                } else {
                    selected.push(file[i]);
                }
            } else {
                this.denied.items.push({
                    name: file[i].name,
                    size: file[i].size,
                    errorMessage: this.transloco.translate('admin.format_rejected')
                });
                continue;
            }
        }
        this.denied.refresh();
        if (selected.length !== 0) {
            this.showUploadButton = true;
        } else {
            this.showUploadButton = false;
        }
        this.files = new wjcCore.CollectionView(selected);
        this.percentComplete = 0;
        event.target.value = null;
    }

    uploadFiles() {
        if (this.item.id > 0) {
            let formData = new FormData();
            for (let i = 0; i < this.files.items.length; i++) {
                if (this.caption[i] == undefined)
                    this.caption[i] = "file" + i;
                formData.append(this.caption[i], this.files.items[i]);
                formData.append("destination", "/" + this.item.id);
                formData.append("filename", this.files.items[i].name)
            }
            const req = new HttpRequest('POST', ActivePromotionConfig.SERVER_URL + '/auction/upload', formData, {reportProgress: true});
            this.http.request(req).subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    this.percentComplete = Math.round((event.loaded / event.total) * 100);
                }
                if (event.type === HttpEventType.Response) {
                    this.files = new wjcCore.CollectionView([]);
                    this.denied = new wjcCore.CollectionView([]);
                    this.caption = [];
                    this.loadImages();
                }
            });
        } else {
            this.saveItem$().subscribe((response: any) => {
                    this.dataService.query({
                        sql: "SELECT FROM DA_Item WHERE uuid = '" + this.item.uuid + "'",
                        count: "SELECT FROM DA_Item WHERE uuid = '" + this.item.uuid + "'",
                        fetchPlan: "*:1",
                    }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                        if (data.results.length == 1) {
                            this.item = data.results[0];
                            let formData = new FormData();
                            for (let i = 0; i < this.files.items.length; i++) {
                                if (this.caption[i] == undefined)
                                    this.caption[i] = "file" + i;
                                formData.append(this.caption[i], this.files.items[i]);
                                formData.append("destination", "/" + this.item.id);
                                formData.append("filename", this.files.items[i].name)
                            }
                            const req = new HttpRequest('POST', ActivePromotionConfig.SERVER_URL + '/auction/upload', formData, {reportProgress: true});
                            this.http.request(req).subscribe(event => {
                                if (event.type === HttpEventType.UploadProgress) {
                                    this.percentComplete = Math.round((event.loaded / event.total) * 100);
                                }
                                if (event.type === HttpEventType.Response) {
                                    this.files = new wjcCore.CollectionView([]);
                                    this.denied = new wjcCore.CollectionView([]);
                                    this.caption = [];
                                    this.loadImages();
                                }
                            });
                        }
                    })
                }
            )
        }
    }

    removeFile(i: any, type: any) {
        if (type == "allowed") {
            this.files.items.splice(i, 1);
            this.files.refresh();
            this.caption.splice(i, 1);
        } else {
            this.denied.items.splice(i, 1);
            this.denied.refresh();
        }
        if (this.files.items.length == 0) {
            this.showUploadButton = false;
        }
    }

    convertSize(fileSize: number) {
        return fileSize < 1024000 ? (fileSize / 1024).toFixed(2) + " KB" : (fileSize / 1024000).toFixed(2) + " MB";
    }

    drop(event: any) {
        event.stopPropagation();
        event.preventDefault();
        this.onChange(event);
    }

    allowDrop(event: any) {
        event.stopPropagation();
        event.preventDefault();
        event.dataTransfer.dropEffect = "copy";
    }

    addImage() {
        var item = this.imagesAvailable.currentItem;
        if (item) {
            this.imagesAvailable.remove(item);
            this.images.sourceCollection.splice(this.images.sourceCollection.length, 0, item);
            this.images.refresh();
            this.images.moveCurrentTo(item);
        }
    }

    removeImage() {
        var item = this.images.currentItem,
            index = this.imagesAvailable.currentPosition;
        if (item) {
            this.images.remove(item);
            this.imagesAvailable.sourceCollection.splice(Math.max(0, index), 0, item);
            this.imagesAvailable.refresh();
            this.imagesAvailable.moveCurrentTo(item);
        }
    }

    moveImage(offset) {
        var item = this.images.currentItem;
        if (item) {
            var arr = this.images.sourceCollection,
                index = arr.indexOf(item),
                newIndex = index + offset;
            if (index > -1 && newIndex > -1) {
                arr.splice(index, 1);
                arr.splice(newIndex, 0, item);
                this.images.refresh();
                this.images.moveCurrentTo(item);
            }
        }
    }

    getBuyerFunction(query: string, max: number, callback: Function) {
        if (!query) {
            callback(null);
            return;
        }
        let where = [];
        where.push("name LIKE '%" + query + "%'")
        where.push("memberName LIKE '%" + query + "%'")
        where.push("telephone LIKE '%" + query + "%'")
        this.dataService.query({
            sql: "SELECT FROM OUser WHERE status = 'ACTIVE' AND buyer = true AND (" + where.join(" OR ") + ")",
            count: "SELECT FROM OUser WHERE status = 'ACTIVE' AND buyer = true AND (" + where.join(" OR ") + ")",
            fetchPlan: "*:0",
        }, ActivePromotionConfig.SERVER_URL).subscribe(response => {
            if (wjcCore.isArray(response.results)) {
                callback(response.results);
            }
        })
    }

    getBuyer = this.getBuyerFunction.bind(this);

    getSellerFunction(query: string, max: number, callback: Function) {
        if (!query) {
            callback(null);
            return;
        }
        let where = [];
        where.push("name LIKE '%" + query + "%'")
        where.push("memberName LIKE '%" + query + "%'")
        where.push("telephone LIKE '%" + query + "%'")
        this.dataService.query({
            sql: "SELECT FROM OUser WHERE status = 'ACTIVE' AND seller = true AND (" + where.join(" OR ") + ")",
            count: "SELECT FROM OUser WHERE status = 'ACTIVE' AND seller = true AND (" + where.join(" OR ") + ")",
            fetchPlan: "*:0",
        }, ActivePromotionConfig.SERVER_URL).subscribe(response => {
            if (wjcCore.isArray(response.results)) {
                callback(response.results);
            }
        })
    }

    getSeller = this.getSellerFunction.bind(this);

}

